<template>
  <div>
    <div class="wrapper" :style="dynamicStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "GridLayout",
  props: {
    width: {
      required: true,
      type: Number
    }
  },
  computed: {
    dynamicStyle() {
      return {
        "--item-width": `${this.width}px`
      };
    }
  }
};
</script>

<style>
:root {
  --item-width: 255px;
}

.wrapper {
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(var(--item-width), 1fr));
  gap: 16px;
}
</style>
